import React from 'react';
import { Box, Stack, Typography, alpha } from '@mui/material';

const SliderSection = ({ section, sectionKey, sliderImages, renderHtmlTextBlock }) => {
  return (
    <Box component="section" sx={{ py: { xs: 1, md: 1.6 }, px: 0, backgroundColor: '#0B1220', width: '100%' }}>
      <Stack spacing={5} sx={{ width: '100%' }}>
        {(section.title || section.body) && (
          <Stack spacing={2} sx={{ textAlign: 'center', color: '#FFFFFF', maxWidth: 800, mx: 'auto' }}>
            {section.title && <Typography sx={{ color: '#FFFFFF', fontWeight: 800, fontSize: { xs: '2rem', md: '3rem' }, letterSpacing: '-0.02em' }}>{section.title}</Typography>}
            {section.body && <Box sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '1.1rem', lineHeight: 1.6 }}>{renderHtmlTextBlock(section.body, { color: 'inherit' })}</Box>}
          </Stack>
        )}

        {sliderImages.length ? (
          <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }, gridAutoRows: { xs: 280, md: 360 } }}>
            {sliderImages.map((imageUrl, index) => (
              <Box key={`${sectionKey}-slider-${index}`} sx={{ position: 'relative', overflow: 'hidden', borderRadius: '32px', backgroundColor: '#111', cursor: 'pointer', '&:hover img': { transform: 'scale(1.08)' } }}>
                <Box component="img" src={imageUrl} alt={`Campus ${index + 1}`} sx={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)' }} />
                <Box sx={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, transparent 40%, rgba(0,0,0,0.8) 100%)', pointerEvents: 'none' }} />
              </Box>
            ))}
          </Box>
        ) : (
          <Box sx={{ py: 8, textAlign: 'center', border: '2px dashed rgba(255,255,255,0.2)', borderRadius: '32px' }}>
            <Typography sx={{ color: 'rgba(255,255,255,0.6)' }}>Add campus images in the editor.</Typography>
          </Box>
        )}
      </Stack>
    </Box>
  );
};
export default SliderSection;
